import { useAppTranslation } from "./useAppTranslation";
import { PaymentStatusEnum } from "@payping/api";
import { TicketStatusEnum } from "@payping/api/app/api/ticketgatewayTypes";

interface EnumStatusType {
  name?: string;
  color?: "success" | "processing" | "error" | "default" | "warning";
}

export const useEnumTranslation = () => {
  const { t } = useAppTranslation();

  function getTicketStatus(status?: number) {
    switch (status) {
      case -1:
        return { label: t("ticketing.status.all"), color: "blue" as const };
      case TicketStatusEnum.Open:
        return { label: t("ticketing.status.open"), color: "blue" as const };
      case TicketStatusEnum.InProgress:
        return { label: t("ticketing.status.inProgress"), color: "orange" as const };
      case TicketStatusEnum.Wait:
        return { label: t("ticketing.status.wait"), color: "orange" as const };
      case TicketStatusEnum.Closed:
        return { label: t("ticketing.status.closed"), color: "green" as const };
      case TicketStatusEnum.Unknown:
      default:
        return { label: t("ticketing.status.unknown"), color: "default" as const };
    }
  }

  function getPaymentStatus(status?: PaymentStatusEnum): EnumStatusType {
    switch (status) {
      case PaymentStatusEnum.ReadyForProcess:
        return { name: t("report.filters.paymentStatus.ReadyForProcess"), color: "default" };
      case PaymentStatusEnum.Succeeded:
        return { name: t("report.filters.paymentStatus.Succeeded"), color: "success" };
      case PaymentStatusEnum.Reversed:
        return { name: t("report.filters.paymentStatus.Reversed"), color: "success" };
      case PaymentStatusEnum.PendingForSettlement:
        return { name: t("report.filters.paymentStatus.PendingForSettlement"), color: "processing" };
      case PaymentStatusEnum.Failed:
        return { name: t("report.filters.paymentStatus.Failed"), color: "error" };
      case PaymentStatusEnum.SuspiciousVerification:
        return { name: t("report.filters.paymentStatus.SuspiciousVerification"), color: "error" };
      case PaymentStatusEnum.SuspiciousReverse:
        return { name: t("report.filters.paymentStatus.SuspiciousReverse"), color: "warning" };
      default:
        return {};
    }
  }

  return {
    getTicketStatus,
    getPaymentStatus,
  };
};
